export interface SmartOrderParams {
  businessOrganizationUUID: string;
  smartOrderUUID: string;
  username: string;
}

export interface SearchInputType {
  search_term: string;
}

export const extractSmartOrderParams = (
  query?: Record<string, string | string[] | undefined>,
): SmartOrderParams | null => {
  const { sessionKey, smartOrderID, userID } = query || {};
  return typeof sessionKey === 'string' &&
    typeof smartOrderID === 'string' &&
    typeof userID === 'string'
    ? {
        businessOrganizationUUID: sessionKey,
        smartOrderUUID: smartOrderID,
        username: userID,
      }
    : null;
};
